<template>
  <div>
    <a-row>
      <a-col :span="18">
        <a-statistic-countdown
          :value="tglStart"
          style="text-align: center"
          @finish="onFinish"
        />
      </a-col>
      <a-col :span="4" style="text-align:right">
        <a-avatar
          shape="square"
          size="large"
          placeholder="Selesai Ujian"
          :style="{ backgroundColor: '#f00', paddingTop:'4px', cursor:'pointer' }"
           @click="inFinish()"   
        >
          <a-icon
            type="poweroff"
            :style="{ fontSize: '24px', color: '#fff' }"
                    
          />
        </a-avatar>

        <!-- <a-icon type="smile" theme="twoTone" />
    <a-icon type="heart" theme="twoTone" two-tone-color="#eb2f96" />
    <a-icon type="check-circle" theme="twoTone" two-tone-color="#52c41a" /> -->
      </a-col>
    </a-row>
  </div>
</template>
<script>
export default {
  props: ["tglStart"],
  data() {
    return {
      spinning: true,
      // deadline: 1800000,
    };
  },
  methods: {
    onFinish() {
      this.$emit("finish-examp", this.spinning);
    },
    inFinish() {
      this.$emit("in-finish-examp", this.spinning);
    },
  },

  // created(){
  //   this.deadline = this.tglStart + 1800000
  // }
};
</script>

<style>
.boxtime {
  border: 2px solid rgb(114, 114, 114);
  padding: 10px 0px;
}
</style>